import { memo } from 'react'
import { useIntl } from 'react-intl'
import type { CellValue, IdType } from 'react-table'
import { mdiArrowRight } from '@mdi/js'
import type { State } from '@racepointenergy/swc/scs/features/host-states'

import { messages } from './messages'
import theme from 'theme_'
import { Body12, BodyPrimary } from 'components/Typography/Labels'
import {
  MobileTableBlock,
  MobileTableBlockCell,
  MobileTableBlockRow,
} from 'components/Table/MobileBlock/styles'
import { StyledMForwardIcon } from './styles'

interface PanelBlockProps {
  values: Record<IdType<State>, CellValue>
  original: Record<IdType<State>, CellValue>
}

export function PanelBlock({ values }: PanelBlockProps) {
  const { formatMessage } = useIntl()
  return (
    <MobileTableBlock>
      <MobileTableBlockRow>
        <MobileTableBlockCell>
          <BodyPrimary bold color={theme.colors.otterWarmBlack}>
            {values.Name}
          </BodyPrimary>
        </MobileTableBlockCell>
        <MobileTableBlockCell>
          <StyledMForwardIcon path={mdiArrowRight} size={1} />
        </MobileTableBlockCell>
      </MobileTableBlockRow>
      <MobileTableBlockRow>
        <MobileTableBlockCell>
          <Body12 color={theme.colors.darkeyGrey}>
            {formatMessage(messages.headerType)}
          </Body12>
        </MobileTableBlockCell>
        <MobileTableBlockCell>
          <BodyPrimary color={theme.colors.otterWarmBlack}>
            {values.Type}
          </BodyPrimary>
        </MobileTableBlockCell>
      </MobileTableBlockRow>
      <MobileTableBlockRow>
        <MobileTableBlockCell>
          <Body12 color={theme.colors.darkeyGrey}>
            {formatMessage(messages.headerRoom)}
          </Body12>
        </MobileTableBlockCell>
        <MobileTableBlockCell>
          <BodyPrimary color={theme.colors.otterWarmBlack}>
            {values.Room}
          </BodyPrimary>
        </MobileTableBlockCell>
      </MobileTableBlockRow>
      <MobileTableBlockRow>
        <MobileTableBlockCell>
          <Body12 color={theme.colors.darkeyGrey}>
            {formatMessage(messages.headerSize)}
          </Body12>
        </MobileTableBlockCell>
        <MobileTableBlockCell>
          <BodyPrimary color={theme.colors.otterWarmBlack}>
            {values.Size}
          </BodyPrimary>
        </MobileTableBlockCell>
      </MobileTableBlockRow>
    </MobileTableBlock>
  )
}

export default memo(PanelBlock)
